
export default {
  props: {
    activityData: {
      default: null
    },
    activityLink:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      actData: this.activityData
    }
  },
  methods: {
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },

    goToLink(links) {
      if(this.actData && this.actData.post && this.actData.post.slug){
        this.$emit('blogIdSent', this.actData.post.slug)
      }
      if (links){
        this.$router.push({ path: links })
      }
      else if(this.actData && this.actData.post && this.actData.post.slug){
      this.$router.push({ path: `/activities/${this.actData.post.slug}` })}
    },

    isSellerVenuePresent(activity) {
      if (activity && activity.seller && activity.seller.length > 0 && activity.seller[0].venue && activity.seller[0].venue.city && activity.seller[0].venue.city.name) {
        return true
      }
      return false
    },

    isSellerPricePresent(activity) {
      if (activity && activity.seller && activity.seller.length > 0 && activity.seller[0].tickets && activity.seller[0].tickets.length > 0
        && activity.seller[0].tickets[0].prices && activity.seller[0].tickets[0].prices.length > 0) {
        return true
      }
      return false
    },

    isPostPricePresent(activity) {
      if (activity && activity.post && (activity.post.strikePrice || activity.post.activityPrice)) {
        return true
      }
      return false
    },

    getStrikePrice(activity) {
      if (this.isSellerPricePresent(activity)) {
        return activity.seller[0].tickets[0].prices[0].strikePrice
      }
      else if (activity && activity.post && activity.post.strikePrice) {
        return activity.post.strikePrice
      }
      else return null
    },

    getSellerPrice(activity) {
      if (this.isSellerPricePresent(activity)) {
        return activity.seller[0].tickets[0].prices[0].price
      }
      else if (activity && activity.post && activity.post.activityPrice) {
        return activity.post.activityPrice
      }
      else return null
    },


    activitiesImage(image) {
      if (image && image.length > 0) {
        return image[0];
      } else {
        return null;
      }
    },

    //To calculate percentage of price and strike price
    activitySellerPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },
    activitySellerDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },
    checkIsOffer(seller) {
      let strikePrice = 0;
      let price = 0
      if (seller) {
        strikePrice = this.activitySellerPrice(seller);
        price = this.activitySellerDiscountPrice(seller);
      }
      else if (this.actData && this.actData.post) {
        strikePrice = this.actData.post.strikePrice ? this.actData.post.strikePrice : 0;
        price = this.actData.post.activityPrice ? this.actData.post.activityPrice : 0;
      }
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(activity) {
      let seller = activity && activity.seller && activity.seller.length > 0 ? activity.seller : null
      if (this.checkIsOffer(seller)) {
        let strikePrice = 0;
        let price = 0
        if (seller) {
          strikePrice = this.activitySellerPrice(seller);
          price = this.activitySellerDiscountPrice(seller);
        }
        else if (this.actData && this.actData.post) {
          strikePrice = this.actData.post.strikePrice ? this.actData.post.strikePrice : 0;
          price = this.actData.post.activityPrice ? this.actData.post.activityPrice : 0;
        }
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    bookingCalculator(value) {

      if (value < 1000) {
        if (value > 100) {
          let val = parseInt(value / 100, 10) * 100;
          return val
        }
        else {
          return value
        }

      } else {
        let len = value.length;
        let sym = len > 6 ? 'm' : 'k';
        let firstDigit = value.toString()[0];
        return firstDigit + sym
      }
    },
  }

}

